import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PeriodicTable from "@/pages/PeriodicTable";
import Topics from "@/pages/Topics";
import TopicDetail from "@/pages/TopicDetail";
import Quiz from "@/pages/Quiz";
import Tutor from "@/pages/Tutor";
import Balancer from "@/pages/Balancer";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Simulator from "@/pages/Simulator";
import Teacher from "@/pages/Teacher";
import CustomQuiz from "@/pages/CustomQuiz";
import Playlist from "@/pages/Playlist";
import MoleculeSearch from "@/pages/MoleculeSearch";
import DailyChallenge from "@/pages/DailyChallenge";
import Leaderboard from "@/pages/Leaderboard";
import Curriculum from "@/pages/Curriculum";
import Lesson from "@/pages/Lesson";
import Mistakes from "@/pages/Mistakes";
import Roster from "@/pages/Roster";
import ClassChat from "@/pages/ClassChat";
import Offline from "@/pages/Offline";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/table" element={<PeriodicTable />} />
            <Route path="/topics" element={<Topics />} />
            <Route path="/topics/:id" element={<TopicDetail />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/:topicId" element={<Quiz />} />
            <Route path="/tutor" element={<Tutor />} />
            <Route path="/balancer" element={<Balancer />} />
            <Route path="/simulator" element={<Simulator />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/teacher" element={<Teacher />} />
            <Route path="/teacher/roster" element={<Roster />} />
            <Route path="/teacher/quizzes/:qid/leaderboard" element={<Leaderboard />} />
            <Route path="/mistakes" element={<Mistakes />} />
            <Route path="/class" element={<ClassChat />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="/molecules" element={<MoleculeSearch />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/curriculum/:year/:order" element={<Lesson />} />
            <Route path="/daily" element={<DailyChallenge />} />
            <Route path="/playlist" element={<Playlist />} />
            <Route path="/login" element={<Login />} />
            <Route path="/c/:qid" element={<CustomQuiz />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
